import styled from '@emotion/styled';

interface IconProps {
  small?: boolean;
}

const CircleIconShadow = styled('div')<IconProps>`
  height: ${(props) => (props.small ? '16px' : '34px')};
  min-width: ${(props) => (props.small ? '16px' : '34px')};
  margin-right: 5px;
  margin-top: 10px;
  position: relative;
  top: 3px;
  border-radius: 50%;
  bottom: 5px;
  -webkit-box-shadow: 0 0 16px 3px rgba(0, 0, 0, 0.05);
  box-shadow: 0 0 16px 3px rgba(0, 0, 0, 0.05);
  display: inline-block;
  position: relative;
`;

export default CircleIconShadow;
